<template>    
    <BaseModal
        :id="'static-associate'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0"  @submit.prevent="form_submit_update()">
                <FormDynamic
                    v-if="view_by_associate"
                    :form_format="form_format"
                    :form_data="single_object"
                    :array_options="array_options"
                    :for_update="true"
                />
                <div class="p-0 formdynamic__item" :style="`margin-top:20px`" v-if="local_object && Object.keys(local_object).length && !view_by_associate">
                    <div class="formdynamic__item__field" id="multiselect__schedule">
                        <label v-html="'Associates'" class="modal-label mb-1" :for="`assignment`"/>
                        <multiselect v-model="local_object.associates"  :options="array_options.associate_id" :multiple="true" :close-on-select="false" :clear-on-select="false" :taggable="true" :preserve-search="true" placeholder="Select associates" label="name" track-by="id" :preselect-first="false">
                        </multiselect>
                    </div>
                </div>
                <CentralLiteButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralLiteButtons  from '@/components/CentralLiteButtons'
import Multiselect  from    "vue-multiselect"

export default {

    name:   'FormModalAssociate',
    props: [
        'title',
        'rest_api',
        'notyf',
        'single_object',
        'template_index',
        'schedule_index',
        "array_options",
        "breadcrumb",
        "parent",
        "indexes",
        "templates",
        "next_start_date",
        "view_by_associate"
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
        Multiselect
    },

    data(){
        return{
            form_format: FormResources.form_format_associate,
            local_object: null
        }
    },
    
    methods:{
        reset(single_object)
        {
            this.local_object = {...single_object}
        },

        async form_submit_update()
        {
            this.loader(true)

            let http_request

            if(this.view_by_associate)
            {
                this.templates[this.indexes.row_index] = this.single_object

                http_request = {
                    local_object: this.single_object,
                    date: this.next_start_date,
                    full_schedule: this.templates,
                    rotation_id: this.parent.id,
                    view_by_associate: true
                }
            }
            else 
            {
                http_request = {

                    rotation_id: this.parent.id,
                    schedule_id: this.templates[this.indexes.row_index].id,
                    date: this.next_start_date,
                    local_object: this.local_object,
                    daily_assignment_id:  this.templates[this.indexes.row_index].daily_assignment_id,
                    view_by_associate: false
                }
            }

            const response = await this.patch(`${this.rest_api}/${this.single_object.id}`, http_request)

            if(response.status)
            {
                let response_object = {
                    template_index: this.template_index,
                    template_object: response.data.data,
                }
                this.$emit('spliceObject', response_object)
                this.notyf.success(`Success!`)
                this.loader()
            } 
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },
    },

    mounted(){

    }
    
}
</script>